var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConstruction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cube-04"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M13.6667 10.6667H5.33333M5.33333 10.6667V2.33333M5.33333 10.6667L2.33333 13.6667M2.33333 5.33333H10.6667M10.6667 5.33333V13.6667M10.6667 5.33333L13.6667 2.33333M14 10.2248V2.53333C14 2.34665 14 2.25331 13.9637 2.182C13.9317 2.11928 13.8807 2.06829 13.818 2.03633C13.7467 2 13.6534 2 13.4667 2H5.77516C5.6121 2 5.53057 2 5.45385 2.01842C5.38582 2.03475 5.32079 2.06169 5.26114 2.09824C5.19387 2.13947 5.13622 2.19712 5.02091 2.31242L2.31242 5.02091C2.19712 5.13621 2.13947 5.19387 2.09824 5.26114C2.06169 5.32079 2.03475 5.38582 2.01842 5.45385C2 5.53057 2 5.6121 2 5.77516V13.4667C2 13.6534 2 13.7467 2.03633 13.818C2.06829 13.8807 2.11928 13.9317 2.182 13.9637C2.25331 14 2.34665 14 2.53333 14H10.2248C10.3879 14 10.4694 14 10.5462 13.9816C10.6142 13.9652 10.6792 13.9383 10.7389 13.9018C10.8061 13.8605 10.8638 13.8029 10.9791 13.6876L13.6876 10.9791C13.8029 10.8638 13.8605 10.8061 13.9018 10.7389C13.9383 10.6792 13.9652 10.6142 13.9816 10.5462C14 10.4694 14 10.3879 14 10.2248Z",
    stroke: "#01588C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruction);
export default __webpack_public_path__ + "static/media/construction.8ce38efbea5fc2272f45453f34f97b0e.svg";
export { ForwardRef as ReactComponent };